import * as React from "react";
import { IAppointmentConfirmationProps } from "../Types";
import { renderAppointmentsList, renderConfirmationButtons } from "../SubComponents";
import { IOrientationProps } from "../../PatientOverview/Types";
import { TypeOfFinalTransaction } from "../../../dtos/KioskDtos.dtos";
const failImage = require('../../../assets/images/fail-error.png');

export const LateAppointmentScenario = (props: IAppointmentConfirmationProps & IOrientationProps) => (
    <div>
        {renderAppointmentsList(props.appointments.lateAppointments, true, props)}
        <div className="row">
            <div className="col-md-12 text-center">
                <h3 className="validation-block" style={{ fontSize: "35px", padding: "0 25px" }}>
                    {
                        props.appointments.lateAppointments.length === 1
                            ? props.textString.messagesInstructions.CantCheckinForThisAppointmentMessage
                            : props.textString.messagesInstructions.CantCheckinForTheseAppointmentsMessage
                    }
                </h3>
                <p style={{ fontWeight: "bold", fontSize: "45px"}}>{props.textString.messagesInstructions.PleaseSeeReceptionMessage}</p>
                <img src={failImage} style={{ width: "250px" }} />
            </div>
        </div>
        {renderConfirmationButtons(false, props, props.isLoadingSpinnerActive, TypeOfFinalTransaction.PatientInformedOfLateAppointments)}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/AppointmentConfirmation/Scenarios/LateAppointmentScenario.tsx